import { DatePipe } from '@angular/common';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MonacoEditorModule, NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';
import { ConfirmationService, MessageService } from 'primeng/api';

import { HttpTranslateLoader } from '../../app.module';

import { ConfigService } from '../../services/app-config.service';
import { AppService } from '../../services/app.service';
import { AuthGuardService } from '../../services/auth-guard.service';
import { InitialDataResolver } from '../../services/initial-data.resolver';
import { MessageService as MessageServiceTemplate } from '../../services/message.service';
import { SystemService } from '../../services/system.service';
import { UserService } from '../../services/user.service';
import { CoreRoutes } from './core.routing';

import { LoadingBarModule } from "@ngx-loading-bar/core";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { NgxMaskDirective } from 'ngx-mask';
import { HttpErrorHandlingInterceptor } from '../../interceptors/http-error-handling.interceptor';
import { PaginatedService } from '../../services/paginated.service';


const monacoConfig: NgxMonacoEditorConfig = {
  baseUrl: '/assets',
  defaultOptions: { scrollBeyondLastLine: false },
  requireConfig: { preferScriptTags: true }
};

export const coreConfig: ApplicationConfig = {
  providers: [
    provideRouter(CoreRoutes),
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(BrowserModule, LoadingBarModule, LoadingBarHttpClientModule, LoadingBarRouterModule, NgxMaskDirective, MonacoEditorModule.forRoot(monacoConfig), AngularSvgIconModule.forRoot(), TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpTranslateLoader,
        deps: [HttpClient]
      }
    })),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorHandlingInterceptor, multi: true },
    DatePipe,
    MessageService,
    ConfirmationService,
    PaginatedService,
    AppService,
    AuthGuardService,
    SystemService,
    UserService,
    ConfigService,
    MessageServiceTemplate,
    InitialDataResolver
  ]
};
